import { render, staticRenderFns } from "./upPay.vue?vue&type=template&id=8e627274&scoped=true"
import script from "./upPay.vue?vue&type=script&lang=js"
export * from "./upPay.vue?vue&type=script&lang=js"
import style0 from "./upPay.vue?vue&type=style&index=0&id=8e627274&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8e627274",
  null
  
)

export default component.exports